import Headroom from 'headroom.js';
import {find, fire, on, addClass, removeClass, hasClass} from '../helpers';

const header = find('[data-header]');
const stickyBar = find('[data-sticky-bar]');

const update = (elem, add, remove) => {
    removeClass(elem, remove);
    addClass(elem, add);

    return null;
};

on('stickit', () => {
    if (hasClass(header, 'headroom--unpinned')) {
        update(header, 'headroom--pinned', 'headroom--unpinned');
    }
});

const init = () => {
    new Headroom(header, {
        offset: header.clientHeight,
        onPin: () => fire('sticky-sidebars::change', update(stickyBar, 'top-24', 'top-4')),
        onBottom: () => fire('sticky-sidebars::change', update(stickyBar, 'top-24', 'top-4')),
        onUnpin: () => {
            fire('sticky-sidebars::change', update(stickyBar, 'top-4', 'top-24'));
        },
        onNotTop: () => {
            fire('sticky-sidebars::change', update(stickyBar, 'top-24', 'top-4'));
            if (window.innerWidth > 1024) {
                fire('close-menu', window);
            }
            // fire('close-dropdown', window);
            // Close all <el-popover> by removing 'open' attribute
            // const menus = document.querySelectorAll('data-menu');
            //
            // menus.forEach(menu => removeClass(menu, ''));
        },
    }).init();
};

on('load', init, window);
